import bowser from 'bowser';

export default angular
  .module('doxy.common.services.screenshareFactory', [])
  .factory(
    'screenshareFactory',
    function ($window, $log, Browser, notificationFactory, globalUi) {
      function installChromePlugin() {
        const message =
          'Plugin failed to install. Please visit ' +
          '<a href="https://chrome.google.com/webstore/detail/' +
          'hpohjmcciikpccgjfbjopmjcieefnaem" target="_blank">Chrome Web Store</a> ' +
          'to do it manually.';

        const handleError = function (err) {
          $log.error('installChromePlugin', {
            action: 'installChromePlugin',
            error: err,
          });
          notificationFactory.showCommon('error', message);
        };

        if (!$window.chrome.webstore) {
          handleError(
            'Inline-Installation Deprecation https://developer.chrome.com/extensions/inline_faq'
          );
          return;
        }
        $window.chrome.webstore.install(
          'https://chrome.google.com/webstore/detail/hpohjmcciikpccgjfbjopmjcieefnaem',
          function () {
            notificationFactory.showCommon(
              'info',
              'Now please refresh the page.'
            );
          },
          handleError
        );
      }

      function notSupported() {
        notificationFactory.showCommon(
          'error',
          'Current browser does not support screensharing, please use Chrome or Firefox instead.'
        );
      }

      function pluginNotInstalled(extensionRequired) {
        let message = undefined;
        if (bowser.chrome) {
          message =
            'Please update your browser to the latest version or install plugin by <a onclick="installChromePlugin()">this link</a>. Refresh this page after installation';
        } else if (extensionRequired === 'chrome') {
          message =
            'Please install plugin by <a onclick="installChromePlugin()">this link</a>. Refresh this page after installation';
        }

        if (bowser.firefox) {
          message = 'Please update your browser to the latest version.';
        }

        if (message) notificationFactory.showUnsafeMessage('info', message);
      }

      function getErrorMessageKey() {
        if (Browser.isMacOs() && !Browser.isSafari()) {
          return 'screenshare-not-supported-macos';
        }
        if (Browser.isMacOs() && Browser.isSafari()) {
          return 'screenshare-not-supported-macos-safari';
        }

        return 'screenshare-not-supported-common';
      }

      $window.installChromePlugin = installChromePlugin;

      return {
        pluginNotInstalled,
        notSupported,
        handleError(error) {
          globalUi.ui.screenSharing = false;
          switch (error.code) {
            case 1500:
              const messageKey = getErrorMessageKey();
              notificationFactory.showCommon('info', messageKey);
              break;
            default:
              notificationFactory.showCommon(
                'error',
                'Could not start screensharing.'
              );
            // notificationFactory.showCommon('info', 'screenshare-random-error');
          }
        },
      };
    }
  ).name;
